import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ThumbDown = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <path
        d="M14.1659 3.33333L11.0326 2.55C10.9004 2.51687 10.7646 2.50008 10.6284 2.5H7.28005C6.97048 2.50001 6.66702 2.58624 6.4037 2.74903C6.14038 2.91183 5.9276 3.14474 5.78922 3.42167L2.87255 9.255C2.74558 9.5091 2.68566 9.79143 2.69847 10.0752C2.71129 10.359 2.79642 10.6347 2.94578 10.8764C3.09514 11.118 3.30378 11.3174 3.55189 11.4557C3.79999 11.594 4.07933 11.6667 4.36339 11.6667H8.33339H10.0001M14.1659 3.33333L14.1667 10.8333L11.3401 15.0733C11.0092 15.5692 10.8334 16.1508 10.8334 16.7467C10.8334 17.1625 10.4959 17.5 10.0792 17.5H9.99922C9.55719 17.5 9.13327 17.3244 8.82071 17.0118C8.50815 16.6993 8.33255 16.2754 8.33255 15.8333V11.6667M14.1659 3.33333H15.8334C16.2754 3.33333 16.6993 3.50893 17.0119 3.82149C17.3245 4.13405 17.5001 4.55797 17.5001 5V10C17.5001 10.442 17.3245 10.866 17.0119 11.1785C16.6993 11.4911 16.2754 11.6667 15.8334 11.6667H13.7501"
        stroke={color}
        strokeOpacity="0.8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default ThumbDown
